export default __webpack_public_path__ + "static/python-web-development-fd81342c0b73e566af607c4fabbfa046.webp";